import { app } from "modular-openscriptjs";
import { EchoEventListener } from "./classes/EchoEventListener";
import { channelRoutes } from "./echo-channels";
/**
 * @type {EchoEventListener} echoEventListener
 */
let echoEventListener = app("EchoEventListener");

export function activateEchoListeners() {
    echoEventListener.listenToNotifications(channelRoutes.currentUser());
}
